import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectPeopleArray } from 'services/people/selectors';
import {
    makeSelectUsersMePersonValue,
    makeSelectUsersMeValue
} from '../../services/usersMe/selectors';

// Utils
import orderBy from '../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectFilteredData = createDeepEqualSelector(
    selectPeopleArray,
    peopleArrayState => peopleArrayState.filter(value => value.email)
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'fullName')
);

const selectOptions = createDeepEqualSelector(
    [
        selectOrderedData,
        makeSelectUsersMeValue('email'),
        makeSelectUsersMePersonValue('fullName')
    ],
    (orderedDataState, usersMeEmailState, usersMePersonFullNameState) =>
        [
            {
                key: usersMeEmailState,
                content: 'Assign to me',
                text: usersMePersonFullNameState,
                value: usersMeEmailState
            }
        ].concat(
            orderedDataState
                .map(({ email, fullName }) => ({
                    key: email,
                    content: fullName,
                    text: fullName,
                    value: email
                }))
                .filter(({ value }) => value !== usersMeEmailState)
        )
);

export { selectOptions };
